import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { MappedError } from "@becon-team/becon-fe-lib/my-axios";
import { path } from "utils/(path)";

// message가 falsy일 때 코드의 기본 메시지를 보여줌
export const useErrorCodeMap = (): Record<string, MappedError> => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return {
    DUPLICATED_EMAIL: {
      type: "WARNING",
      message: `${t("이미 등록된 이메일이에요.")} ${t("다른 이메일을 사용해 주세요.")}`,
    },
    USER_NOT_FOUND: {
      message: t("존재하지 않는 고객이에요."),
      action: {
        btnName: t("홈으로"),
        onClick: () => {
          navigate("/");
        },
      },
    },
    PHONE_NUMBER_NOT_FOUND: {
      type: "NOT_NOTIFY",
      message: t("휴대폰번호를 등록해주세요"),
    },
    // 날씨 api limit 초과날 경우
    WEATHER_UNAVAILABLE: {
      type: "NOT_NOTIFY",
    },
    // 위도 경도 값이 유효하지 않은 경우
    VALIDATION_FAILED: {
      type: "NOT_NOTIFY",
    },
    VERIFICATION_CODE_NOT_MATCHED: {
      type: "WARNING",
      message: t("입력하신 인증 코드가 정확하지 않습니다 다시 입력해 주세요"),
    },
    INVALID_NUMBERS_FORMAT: {
      type: "WARNING",
      message: t("휴대폰 번호 형식이 올바르지 않아요."),
    },
    VERIFICATION_CODE_EXPIRED: {
      type: "WARNING",
      message: t("인증 코드의 유효 시간이 초과되었습니다 새로운 인증 코드를 받아주세요"),
    },
    AUTH_EXPIRED: {
      type: "NOT_NOTIFY",
    },
    B2C_ACCOUNT_NOT_FOUND: {
      type: "WARNING",
      // 가입된 계정이 없어요. 회원가입 후 이용해 주세요.
      message: t("B2C_ACCOUNT_NOT_FOUND"),
      action: {
        btnName: t("회원가입"),
        onClick: () => {
          navigate(path.authSignup());
        },
      },
    },
  };
};
